// if (!customElements.get('product-info')) {
//   customElements.define(
//     'product-info',
//     class ProductInfo extends HTMLElement {
//       quantityInput = undefined;
//       quantityForm = undefined;
//       onVariantChangeUnsubscriber = undefined;
//       cartUpdateUnsubscriber = undefined;
//       abortController = undefined;
//       pendingRequestUrl = null;
//       preProcessHtmlCallbacks = [];
//       postProcessHtmlCallbacks = [];

//       constructor() {
//         super();

//         this.quantityInput = this.querySelector('.quantity__input');
//       }

//       connectedCallback() {
//         this.initializeProductSwapUtility();

//         this.onVariantChangeUnsubscriber = subscribe(
//           PUB_SUB_EVENTS.optionValueSelectionChange,
//           this.handleOptionValueChange.bind(this)
//         );

//         this.initQuantityHandlers();
        
//         if(window.matchMedia('(min-width: 990px)').matches) 
//           this.hideOtherVariantImages();
//         this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));


//         document.addEventListener("DOMContentLoaded", () => {
//           const productSwiperSlider = document.querySelector('#pdpSwiperSlider');
//           productSwiperSlider.style.opacity = 1;          
//         });
//       }

//       addPreProcessCallback(callback) {
//         this.preProcessHtmlCallbacks.push(callback);
//       }

//       initQuantityHandlers() {
//         if (!this.quantityInput) return;

//         this.quantityForm = this.querySelector('.product-form__quantity');
//         if (!this.quantityForm) return;

//         this.setQuantityBoundries();
//         if (!this.dataset.originalSection) {
//           this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
//         }
//       }

//       disconnectedCallback() {
//         this.onVariantChangeUnsubscriber();
//         this.cartUpdateUnsubscriber?.();
//       }

//       initializeProductSwapUtility() {
//         this.preProcessHtmlCallbacks.push((html) =>
//           html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
//         );
//         this.postProcessHtmlCallbacks.push((newNode) => {
//           window?.Shopify?.PaymentButton?.init();
//           window?.ProductModel?.loadShopifyXR();
//         });
//       }

//       handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
//         if (!this.contains(event.target)) return;

//         this.resetProductFormState();

//         const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
//         this.pendingRequestUrl = productUrl;
//         const shouldSwapProduct = this.dataset.url !== productUrl;
//         const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

//         this.renderProductInfo({
//           requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
//           targetId: target.id,
//           callback: shouldSwapProduct
//             ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
//             : this.handleUpdateProductInfo(productUrl),
//         });
//       }

//       resetProductFormState() {
//         const productForm = this.productForm;
//         productForm?.toggleSubmitButton(true);
//         productForm?.handleErrorMessage();
//       }

//       handleSwapProduct(productUrl, updateFullPage) {
//         return (html) => {
//           this.productModal?.remove();

//           const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
//           const variant = this.getSelectedVariant(html.querySelector(selector));
//           this.updateURL(productUrl, variant?.id);

//           if (updateFullPage) {
//             document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

//             HTMLUpdateUtility.viewTransition(
//               document.querySelector('main'),
//               html.querySelector('main'),
//               this.preProcessHtmlCallbacks,
//               this.postProcessHtmlCallbacks
//             );
//           } else {
//             HTMLUpdateUtility.viewTransition(
//               this,
//               html.querySelector('product-info'),
//               this.preProcessHtmlCallbacks,
//               this.postProcessHtmlCallbacks
//             );
//           }
//         };
//       }

//       renderProductInfo({ requestUrl, targetId, callback }) {
//         this.abortController?.abort();
//         this.abortController = new AbortController();

//         fetch(requestUrl, { signal: this.abortController.signal })
//           .then((response) => response.text())
//           .then((responseText) => {
//             this.pendingRequestUrl = null;
//             const html = new DOMParser().parseFromString(responseText, 'text/html');
//             callback(html);
//           })
//           .then(() => {
//             // set focus to last clicked option value
//             document.querySelector(`#${targetId}`)?.focus();
//           })
//           .catch((error) => {
//             if (error.name === 'AbortError') {
//               console.log('Fetch aborted by user');
//             } else {
//               console.error(error);
//             }
//           });
//       }

//       getSelectedVariant(productInfoNode) {
//         const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
//         return !!selectedVariant ? JSON.parse(selectedVariant) : null;
//       }

//       buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
//         const params = [];

//         !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

//         if (optionValues.length) {
//           params.push(`option_values=${optionValues.join(',')}`);
//         }

//         return `${url}?${params.join('&')}`;
//       }

//       updateOptionValues(html) {
//         const variantSelects = html.querySelector('variant-selects');
//         if (variantSelects) {
//           HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
//         }
//       }

//       handleUpdateProductInfo(productUrl) {
//         return (html) => {
//           const variant = this.getSelectedVariant(html);

//           this.pickupAvailability?.update(variant);
//           this.updateOptionValues(html);
//           this.updateURL(productUrl, variant?.id);
//           this.updateVariantInputs(variant?.id);

//           if (!variant) {
//             this.setUnavailable();
//             return;
//           }

//           this.updateMedia(html, variant?.featured_media?.id);

//           const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
//             const source = html.getElementById(`${id}-${this.sectionId}`);
//             const destination = this.querySelector(`#${id}-${this.dataset.section}`);
//             if (source && destination) {
//               destination.innerHTML = source.innerHTML;
//               destination.classList.toggle('hidden', shouldHide(source));
//             }
//           };

//           updateSourceFromDestination('price');
//           updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
//           updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
//           updateSourceFromDestination('Volume');
//           updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

//           this.updateQuantityRules(this.sectionId, html);
//           this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
//           this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

//           this.productForm?.toggleSubmitButton(
//             html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
//             window.variantStrings.soldOut
//           );

//           publish(PUB_SUB_EVENTS.variantChange, {
//             data: {
//               sectionId: this.sectionId,
//               html,
//               variant,
//             },
//           });
//         };
//       }

//       updateVariantInputs(variantId) {
//         this.querySelectorAll(
//           `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
//         ).forEach((productForm) => {
//           const input = productForm.querySelector('input[name="id"]');
//           input.value = variantId ?? '';
//           input.dispatchEvent(new Event('change', { bubbles: true }));
//         });
//       }

//       updateURL(url, variantId) {
//         this.querySelector('share-button')?.updateUrl(
//           `${window.shopUrl}${url}${variantId ? `?variant=${variantId}` : ''}`
//         );

//         if (this.dataset.updateUrl === 'false') return;
//         window.history.replaceState({}, '', `${url}${variantId ? `?variant=${variantId}` : ''}`);
//       }

//       setUnavailable() {
//         this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

//         const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
//           .map((id) => `#${id}-${this.dataset.section}`)
//           .join(', ');
//         document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
//       }

//       updateMedia(html, variantFeaturedMediaId) {
//         if (!variantFeaturedMediaId) return;
//         const productSwiperSlider = document.querySelector('#pdpSwiperSlider');
//         const stickyAtcSlider = document.querySelector('.sticky-add-to-cart #pdpSwiperSlider');
//         const stickyAtcContent = document.querySelector('.sticky-add-to-cart .quick-add-modal__content-info');
//         const mediaGallerySource = this.querySelector('media-gallery ul');
//         const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

//         const refreshSourceData = () => {
//           if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
//           const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
//           const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
//           const sourceMap = new Map(
//             mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
//           );
//           return [mediaGallerySourceItems, sourceSet, sourceMap];
//         };


//         if (window.matchMedia('(max-width: 990px)').matches) {
//           productSwiperSlider.goToSlide(`product-swiper-slider-${variantFeaturedMediaId}`);
//           if(stickyAtcSlider) stickyAtcSlider.goToSlide(`product-swiper-slider-${variantFeaturedMediaId}`);
//           if(stickyAtcSlider && stickyAtcContent) {
//             stickyAtcContent.scrollTo({ top: 0, behavior: "smooth" })
//           }
//         } else {
//           this.hideOtherVariantImages();
//         }
        

//         if (mediaGallerySource && mediaGalleryDestination) {
//           let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
//           const mediaGalleryDestinationItems = Array.from(
//             mediaGalleryDestination.querySelectorAll('li[data-media-id]')
//           );
//           const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
//           let shouldRefresh = false;

//           // add items from new data not present in DOM
//           for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
//             if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
//               mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
//               shouldRefresh = true;
//             }
//           }

//           // remove items from DOM not present in new data
//           for (let i = 0; i < mediaGallerySourceItems.length; i++) {
//             if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
//               mediaGallerySourceItems[i].remove();
//               shouldRefresh = true;
//             }
//           }

//           // refresh
//           if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

//           // if media galleries don't match, sort to match new data order
//           mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
//             const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

//             if (sourceData && sourceData.index !== destinationIndex) {
//               mediaGallerySource.insertBefore(
//                 sourceData.item,
//                 mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
//               );

//               // refresh source now that it has been modified
//               [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
//             }
//           });
//         }

//         // set featured media as active in the media gallery
//         this.querySelector(`media-gallery`)?.setActiveMedia?.(
//           `${this.dataset.section}-${variantFeaturedMediaId}`,
//           true
//         );

//         // update media modal
//         const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
//         const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
//         if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
//       }

//       // hideOtherVariantImages() {
//       //   const variant = this.getSelectedVariant(document.querySelector('product-info'));
//       //   if (!variant || !variant.id) {
//       //     console.error('Variant not found or missing ID');
//       //     return;
//       //   }
      
//       //   const mediaSlides = document.querySelectorAll('#pdpSwiperSlider .swiper-slide');
//       //   const activeMediaSlidesGroup = 'group-' + this.handleizeString(variant.option1);


//       //   console.log('activeMediaSlidesGroup', activeMediaSlidesGroup)
      
//       //   if (!activeMediaSlidesGroup || activeMediaSlidesGroup === 'group-') {
//       //     console.log('Invalid or empty activeMediaSlidesGroup, returning early.');
//       //     return;
//       //   }
      
//       //   console.log(activeMediaSlidesGroup)
//       //   mediaSlides.forEach(slide => {
//       //     if (String(slide.dataset.groupId) !== String(activeMediaSlidesGroup)) {
//       //       slide.style.display = 'none'; 
//       //     } else {
//       //       slide.style.display = '';
//       //     }
//       //   });
//       // }

//     hideOtherVariantImages() {
//         const productInfoNode = document.querySelector('product-info');
//         const variant = this.getSelectedVariant(productInfoNode);
//         const mediaSlides = document.querySelectorAll('#pdpSwiperSlider .swiper-slide');

//         if (!mediaSlides.length) return;

//         // Build a set of distinct group ids present in the gallery
//         const groups = new Set(
//           Array.from(mediaSlides)
//             .map(s => String(s.dataset.groupId || '').trim())
//             .filter(Boolean)
//         );

//         // Helper: show all slides
//         const showAll = () => mediaSlides.forEach(s => (s.style.display = ''));

//         // If there's only one group (or none) -> do NOT hide anything
//         if (groups.size <= 1) {
//           showAll();
//           return;
//         }

//         // If we don't have a variant or option1, also do not hide
//         if (!variant || !variant.id || !variant.option1) {
//           showAll();
//           return;
//         }

//         const activeGroup = 'group-' + this.handleizeString(variant.option1);

//         // If computed group is empty/invalid or not found among slides -> do not hide
//         if (!activeGroup || !groups.has(activeGroup)) {
//           showAll();
//           return;
//         }

//         // Otherwise, hide slides not in the active group
//         mediaSlides.forEach(slide => {
//           slide.style.display = String(slide.dataset.groupId) === String(activeGroup) ? '' : 'none';
//         });
//     }

      
      


//       // handleizeString(string) {
//       //   return string.trim()
//       //     .toLowerCase() // Convert to lowercase
//       //     .replace(/[\s_]+/g, '-')
//       //     .replace('/', '-') // Replace spaces and underscores with hyphens
//       //     .replace(/[^a-z0-9\-]/g, '') // Remove non-alphanumeric characters, excluding hyphens
//       //     .replace(/-{2,}/g, '-') // Replace multiple consecutive hyphens with a single hyphen
//       //     .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
//       // }

//       handleizeString(str = '') {
//         return String(str)
//           .trim()
//           .toLowerCase()
//           .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
//           .replace(/&/g, '-')
//           .replace(/[^a-z0-9]+/g, '-') 
//           .replace(/^-+|-+$/g, '');
//       }
      
      
      
//       setQuantityBoundries() {
//         const data = {
//           cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
//           min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
//           max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
//           step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
//         };

//         let min = data.min;
//         const max = data.max === null ? data.max : data.max - data.cartQuantity;
//         if (max !== null) min = Math.min(min, max);
//         if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

//         this.quantityInput.min = min;

//         if (max) {
//           this.quantityInput.max = max;
//         } else {
//           this.quantityInput.removeAttribute('max');
//         }
//         this.quantityInput.value = min;

//         publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
//       }

//       fetchQuantityRules() {
//         const currentVariantId = this.productForm?.variantIdInput?.value;
//         if (!currentVariantId) return;

//         this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
//         fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
//           .then((response) => response.text())
//           .then((responseText) => {
//             const html = new DOMParser().parseFromString(responseText, 'text/html');
//             this.updateQuantityRules(this.dataset.section, html);
//           })
//           .catch((e) => console.error(e))
//           .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
//       }

//       updateQuantityRules(sectionId, html) {
//         if (!this.quantityInput) return;
//         this.setQuantityBoundries();

//         const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
//         const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
//         for (let selector of selectors) {
//           const current = this.quantityForm.querySelector(selector);
//           const updated = quantityFormUpdated.querySelector(selector);
//           if (!current || !updated) continue;
//           if (selector === '.quantity__input') {
//             const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
//             for (let attribute of attributes) {
//               const valueUpdated = updated.getAttribute(attribute);
//               if (valueUpdated !== null) {
//                 current.setAttribute(attribute, valueUpdated);
//               } else {
//                 current.removeAttribute(attribute);
//               }
//             }
//           } else {
//             current.innerHTML = updated.innerHTML;
//           }
//         }
//       }

//       get productForm() {
//         return this.querySelector(`product-form`);
//       }

//       get productModal() {
//         return document.querySelector(`#ProductModal-${this.dataset.section}`);
//       }

//       get pickupAvailability() {
//         return this.querySelector(`pickup-availability`);
//       }

//       get variantSelectors() {
//         return this.querySelector('variant-selects');
//       }

//       get relatedProducts() {
//         const relatedProductsSectionId = SectionId.getIdForSection(
//           SectionId.parseId(this.sectionId),
//           'related-products'
//         );
//         return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
//       }

//       get quickOrderList() {
//         const quickOrderListSectionId = SectionId.getIdForSection(
//           SectionId.parseId(this.sectionId),
//           'quick_order_list'
//         );
//         return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
//       }

//       get sectionId() {
//         return this.dataset.originalSection || this.dataset.section;
//       }
//     }
//   );
// }


// class SizeChartTable extends HTMLElement {
//   constructor() {
//     super();
//     this.currentUnit = 'in'; // Default unit
//   }

//   connectedCallback() {
//     // Query elements once the component is attached to the DOM
//     this.navigationButtons = this.querySelectorAll('[size-chart-button]');
//     this.convertableCells = this.querySelectorAll('[convertable-data-cell]');

//     // Add event listeners to buttons
//     this.navigationButtons.forEach(button => {
//       button.addEventListener('click', (e) => {
//         this.convertValues(e.target);
//         this.toggleButtonState(e.target);
//       });
//     });
//   }


//   toggleButtonState(targetButton){
//     this.navigationButtons.forEach(button => {
//       button.removeAttribute('active');
//     });

//     targetButton.setAttribute('active','');
//   }

//   convertValues(target) {
//     const targetUnit = target.getAttribute('size-chart-button');
//     if (this.currentUnit == targetUnit) return;
  
//     this.convertableCells.forEach(cell => {
//       let cellData = parseFloat(cell.getAttribute('convertable-data-cell'));
//       if (isNaN(cellData)) return;
  
//       let convertedValue;
//       if (targetUnit === 'cm') {
//         convertedValue = cellData * 2.54;
//       } else {
//         convertedValue = cellData / 2.54;
//       }

//       convertedValue = Math.round(convertedValue * 20) / 20;
  
//       let formattedValue;
//       if (Number.isInteger(convertedValue)) {
//         formattedValue = convertedValue.toFixed(1); 
//       } else if (convertedValue * 10 % 1 === 0) {
//         formattedValue = convertedValue.toFixed(1); 
//       } else {
//         formattedValue = convertedValue.toFixed(2);
//       }
  
//       // Set the attribute and text content
//       cell.setAttribute('convertable-data-cell', formattedValue);
//       cell.textContent = targetUnit === 'cm'
//         ? formattedValue
//         : formattedValue + '"'; 
//     });
  
//     this.currentUnit = targetUnit;
//   }
  
  
// }

// // Define the custom element
// customElements.define('size-chart-table', SizeChartTable);




if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      quantityInput = undefined;
      quantityForm = undefined;
      onVariantChangeUnsubscriber = undefined;
      cartUpdateUnsubscriber = undefined;
      abortController = undefined;
      pendingRequestUrl = null;
      preProcessHtmlCallbacks = [];
      postProcessHtmlCallbacks = [];

      constructor() {
        super();

        this.quantityInput = this.querySelector('.quantity__input');
      }

      connectedCallback() {
        this.initializeProductSwapUtility();

        this.onVariantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.optionValueSelectionChange,
          this.handleOptionValueChange.bind(this)
        );

        this.initQuantityHandlers();

        if (window.matchMedia('(min-width: 990px)').matches)
          this.hideOtherVariantImages();
        this.dispatchEvent(new CustomEvent('product-info:loaded', { bubbles: true }));


        document.addEventListener("DOMContentLoaded", () => {
          const productSwiperSlider = document.querySelector('#pdpSwiperSlider');
          productSwiperSlider.style.opacity = 1;
        });
      }

      addPreProcessCallback(callback) {
        this.preProcessHtmlCallbacks.push(callback);
      }

      initQuantityHandlers() {
        if (!this.quantityInput) return;

        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;

        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
      }

      disconnectedCallback() {
        this.onVariantChangeUnsubscriber();
        this.cartUpdateUnsubscriber?.();
      }

      initializeProductSwapUtility() {
        this.preProcessHtmlCallbacks.push((html) =>
          html.querySelectorAll('.scroll-trigger').forEach((element) => element.classList.add('scroll-trigger--cancel'))
        );
        this.postProcessHtmlCallbacks.push((newNode) => {
          window?.Shopify?.PaymentButton?.init();
          window?.ProductModel?.loadShopifyXR();
        });
      }

      handleOptionValueChange({ data: { event, target, selectedOptionValues } }) {
        if (!this.contains(event.target)) return;

        this.resetProductFormState();

        const productUrl = target.dataset.productUrl || this.pendingRequestUrl || this.dataset.url;
        this.pendingRequestUrl = productUrl;
        const shouldSwapProduct = this.dataset.url !== productUrl;
        const shouldFetchFullPage = this.dataset.updateUrl === 'true' && shouldSwapProduct;

        this.renderProductInfo({
          requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionValues, shouldFetchFullPage),
          targetId: target.id,
          callback: shouldSwapProduct
            ? this.handleSwapProduct(productUrl, shouldFetchFullPage)
            : this.handleUpdateProductInfo(productUrl),
        });
      }

      resetProductFormState() {
        const productForm = this.productForm;
        productForm?.toggleSubmitButton(true);
        productForm?.handleErrorMessage();
      }

      handleSwapProduct(productUrl, updateFullPage) {
        return (html) => {
          this.productModal?.remove();

          const selector = updateFullPage ? "product-info[id^='MainProduct']" : 'product-info';
          const variant = this.getSelectedVariant(html.querySelector(selector));
          this.updateURL(productUrl, variant?.id);

          if (updateFullPage) {
            document.querySelector('head title').innerHTML = html.querySelector('head title').innerHTML;

            HTMLUpdateUtility.viewTransition(
              document.querySelector('main'),
              html.querySelector('main'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          } else {
            HTMLUpdateUtility.viewTransition(
              this,
              html.querySelector('product-info'),
              this.preProcessHtmlCallbacks,
              this.postProcessHtmlCallbacks
            );
          }
        };
      }

      renderProductInfo({ requestUrl, targetId, callback }) {
        this.abortController?.abort();
        this.abortController = new AbortController();

        fetch(requestUrl, { signal: this.abortController.signal })
          .then((response) => response.text())
          .then((responseText) => {
            this.pendingRequestUrl = null;
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            callback(html);
          })
          .then(() => {
            // set focus to last clicked option value
            document.querySelector(`#${targetId}`)?.focus();
          })
          .catch((error) => {
            if (error.name === 'AbortError') {
              console.log('Fetch aborted by user');
            } else {
              console.error(error);
            }
          });
      }

      getSelectedVariant(productInfoNode) {
        const selectedVariant = productInfoNode.querySelector('variant-selects [data-selected-variant]')?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      buildRequestUrlWithParams(url, optionValues, shouldFetchFullPage = false) {
        const params = [];

        !shouldFetchFullPage && params.push(`section_id=${this.sectionId}`);

        if (optionValues.length) {
          params.push(`option_values=${optionValues.join(',')}`);
        }

        return `${url}?${params.join('&')}`;
      }

      updateOptionValues(html) {
        const variantSelects = html.querySelector('variant-selects');
        if (variantSelects) {
          HTMLUpdateUtility.viewTransition(this.variantSelectors, variantSelects, this.preProcessHtmlCallbacks);
        }
      }

      handleUpdateProductInfo(productUrl) {
        return (html) => {
          const variant = this.getSelectedVariant(html);

          this.pickupAvailability?.update(variant);
          this.updateOptionValues(html);
          this.updateURL(productUrl, variant?.id);
          this.updateVariantInputs(variant?.id);

          if (!variant) {
            this.setUnavailable();
            return;
          }

          this.updateMedia(html, variant?.featured_media?.id);

          const updateSourceFromDestination = (id, shouldHide = (source) => false) => {
            const source = html.getElementById(`${id}-${this.sectionId}`);
            const destination = this.querySelector(`#${id}-${this.dataset.section}`);
            if (source && destination) {
              destination.innerHTML = source.innerHTML;
              destination.classList.toggle('hidden', shouldHide(source));
            }
          };

          updateSourceFromDestination('price');
          updateSourceFromDestination('Sku', ({ classList }) => classList.contains('hidden'));
          updateSourceFromDestination('Inventory', ({ innerText }) => innerText === '');
          updateSourceFromDestination('Volume');
          updateSourceFromDestination('Price-Per-Item', ({ classList }) => classList.contains('hidden'));

          this.updateQuantityRules(this.sectionId, html);
          this.querySelector(`#Quantity-Rules-${this.dataset.section}`)?.classList.remove('hidden');
          this.querySelector(`#Volume-Note-${this.dataset.section}`)?.classList.remove('hidden');

          this.productForm?.toggleSubmitButton(
            html.getElementById(`ProductSubmitButton-${this.sectionId}`)?.hasAttribute('disabled') ?? true,
            window.variantStrings.soldOut
          );

          publish(PUB_SUB_EVENTS.variantChange, {
            data: {
              sectionId: this.sectionId,
              html,
              variant,
            },
          });
        };
      }

      updateVariantInputs(variantId) {
        this.querySelectorAll(
          `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
        ).forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = variantId ?? '';
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      updateURL(url, variantId) {
        // Preserve existing query parameters (e.g., Google Ads srsltid) while updating variant
        const currentParams = new URLSearchParams(window.location.search);
        if (variantId) {
          currentParams.set('variant', variantId);
        } else {
          currentParams.delete('variant');
        }
        const queryString = currentParams.toString();
        const newUrl = `${url}${queryString ? `?${queryString}` : ''}`;

        this.querySelector('share-button')?.updateUrl(
          `${window.shopUrl}${newUrl}`
        );

        if (this.dataset.updateUrl === 'false') return;
        window.history.replaceState({}, '', newUrl);
      }

      setUnavailable() {
        this.productForm?.toggleSubmitButton(true, window.variantStrings.unavailable);

        const selectors = ['price', 'Inventory', 'Sku', 'Price-Per-Item', 'Volume-Note', 'Volume', 'Quantity-Rules']
          .map((id) => `#${id}-${this.dataset.section}`)
          .join(', ');
        document.querySelectorAll(selectors).forEach(({ classList }) => classList.add('hidden'));
      }

      updateMedia(html, variantFeaturedMediaId) {
        if (!variantFeaturedMediaId) return;
        const productSwiperSlider = document.querySelector('#pdpSwiperSlider');
        const stickyAtcSlider = document.querySelector('.sticky-add-to-cart #pdpSwiperSlider');
        const stickyAtcContent = document.querySelector('.sticky-add-to-cart .quick-add-modal__content-info');
        const mediaGallerySource = this.querySelector('media-gallery ul');
        const mediaGalleryDestination = html.querySelector(`media-gallery ul`);

        const refreshSourceData = () => {
          if (this.hasAttribute('data-zoom-on-hover')) enableZoomOnHover(2);
          const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
          const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
          const sourceMap = new Map(
            mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }])
          );
          return [mediaGallerySourceItems, sourceSet, sourceMap];
        };


        if (window.matchMedia('(max-width: 990px)').matches) {
          productSwiperSlider.goToSlide(`product-swiper-slider-${variantFeaturedMediaId}`);
          if (stickyAtcSlider) stickyAtcSlider.goToSlide(`product-swiper-slider-${variantFeaturedMediaId}`);
          if (stickyAtcSlider && stickyAtcContent) {
            stickyAtcContent.scrollTo({ top: 0, behavior: "smooth" })
          }
        } else {
          this.hideOtherVariantImages();
        }


        if (mediaGallerySource && mediaGalleryDestination) {
          let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
          const mediaGalleryDestinationItems = Array.from(
            mediaGalleryDestination.querySelectorAll('li[data-media-id]')
          );
          const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
          let shouldRefresh = false;

          // add items from new data not present in DOM
          for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
            if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
              mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
              shouldRefresh = true;
            }
          }

          // remove items from DOM not present in new data
          for (let i = 0; i < mediaGallerySourceItems.length; i++) {
            if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
              mediaGallerySourceItems[i].remove();
              shouldRefresh = true;
            }
          }

          // refresh
          if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

          // if media galleries don't match, sort to match new data order
          mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
            const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

            if (sourceData && sourceData.index !== destinationIndex) {
              mediaGallerySource.insertBefore(
                sourceData.item,
                mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
              );

              // refresh source now that it has been modified
              [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
            }
          });
        }

        // set featured media as active in the media gallery
        this.querySelector(`media-gallery`)?.setActiveMedia?.(
          `${this.dataset.section}-${variantFeaturedMediaId}`,
          true
        );

        // update media modal
        const modalContent = this.productModal?.querySelector(`.product-media-modal__content`);
        const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
        if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
      }

      // hideOtherVariantImages() {
      //   const variant = this.getSelectedVariant(document.querySelector('product-info'));
      //   if (!variant || !variant.id) {
      //     console.error('Variant not found or missing ID');
      //     return;
      //   }

      //   const mediaSlides = document.querySelectorAll('#pdpSwiperSlider .swiper-slide');
      //   const activeMediaSlidesGroup = 'group-' + this.handleizeString(variant.option1);


      //   console.log('activeMediaSlidesGroup', activeMediaSlidesGroup)

      //   if (!activeMediaSlidesGroup || activeMediaSlidesGroup === 'group-') {
      //     console.log('Invalid or empty activeMediaSlidesGroup, returning early.');
      //     return;
      //   }

      //   console.log(activeMediaSlidesGroup)
      //   mediaSlides.forEach(slide => {
      //     if (String(slide.dataset.groupId) !== String(activeMediaSlidesGroup)) {
      //       slide.style.display = 'none'; 
      //     } else {
      //       slide.style.display = '';
      //     }
      //   });
      // }

      hideOtherVariantImages() {
        const productInfoNode = document.querySelector('product-info');
        const variant = this.getSelectedVariant(productInfoNode);
        const mediaSlides = document.querySelectorAll('#pdpSwiperSlider .swiper-slide');

        if (!mediaSlides.length) return;

        // Build a set of distinct group ids present in the gallery
        const groups = new Set(
          Array.from(mediaSlides)
            .map(s => String(s.dataset.groupId || '').trim())
            .filter(Boolean)
        );

        // Helper: show all slides
        const showAll = () => mediaSlides.forEach(s => (s.style.display = ''));

        // If there's only one group (or none) -> do NOT hide anything
        if (groups.size <= 1) {
          showAll();
          return;
        }

        // If we don't have a variant or option1, also do not hide
        if (!variant || !variant.id || !variant.option1) {
          showAll();
          return;
        }

        // Match the slide data-group-id, which now uses the raw (trimmed) option value.
        // handleizeString strips non-Latin chars, breaking color grouping for translated
        // (CJK/Arabic/Thai) color names — so use the raw value on both sides.
        const activeGroup = 'group-' + String(variant.option1 || '').trim();

        // If computed group is empty/invalid or not found among slides -> do not hide
        if (!activeGroup || !groups.has(activeGroup)) {
          showAll();
          return;
        }

        // Otherwise, hide slides not in the active group
        mediaSlides.forEach(slide => {
          slide.style.display = String(slide.dataset.groupId) === String(activeGroup) ? '' : 'none';
        });
      }





      // handleizeString(string) {
      //   return string.trim()
      //     .toLowerCase() // Convert to lowercase
      //     .replace(/[\s_]+/g, '-')
      //     .replace('/', '-') // Replace spaces and underscores with hyphens
      //     .replace(/[^a-z0-9\-]/g, '') // Remove non-alphanumeric characters, excluding hyphens
      //     .replace(/-{2,}/g, '-') // Replace multiple consecutive hyphens with a single hyphen
      //     .replace(/^-+|-+$/g, ''); // Remove leading and trailing hyphens
      // }

      handleizeString(str = '') {
        return String(str)
          .trim()
          .toLowerCase()
          .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
          .replace(/&/g, '-')
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }



      setQuantityBoundries() {
        const data = {
          cartQuantity: this.quantityInput.dataset.cartQuantity ? parseInt(this.quantityInput.dataset.cartQuantity) : 0,
          min: this.quantityInput.dataset.min ? parseInt(this.quantityInput.dataset.min) : 1,
          max: this.quantityInput.dataset.max ? parseInt(this.quantityInput.dataset.max) : null,
          step: this.quantityInput.step ? parseInt(this.quantityInput.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.quantityInput.min = min;

        if (max) {
          this.quantityInput.max = max;
        } else {
          this.quantityInput.removeAttribute('max');
        }
        this.quantityInput.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        const currentVariantId = this.productForm?.variantIdInput?.value;
        if (!currentVariantId) return;

        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${currentVariantId}&section_id=${this.dataset.section}`)
          .then((response) => response.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
          })
          .catch((e) => console.error(e))
          .finally(() => this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden'));
      }

      updateQuantityRules(sectionId, html) {
        if (!this.quantityInput) return;
        this.setQuantityBoundries();

        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      get productForm() {
        return this.querySelector(`product-form`);
      }

      get productModal() {
        return document.querySelector(`#ProductModal-${this.dataset.section}`);
      }

      get pickupAvailability() {
        return this.querySelector(`pickup-availability`);
      }

      get variantSelectors() {
        return this.querySelector('variant-selects');
      }

      get relatedProducts() {
        const relatedProductsSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'related-products'
        );
        return document.querySelector(`product-recommendations[data-section-id^="${relatedProductsSectionId}"]`);
      }

      get quickOrderList() {
        const quickOrderListSectionId = SectionId.getIdForSection(
          SectionId.parseId(this.sectionId),
          'quick_order_list'
        );
        return document.querySelector(`quick-order-list[data-id^="${quickOrderListSectionId}"]`);
      }

      get sectionId() {
        return this.dataset.originalSection || this.dataset.section;
      }
    }
  );
}


if (!customElements.get('size-chart-table')) {
  customElements.define('size-chart-table', class SizeChartTable extends HTMLElement {
  constructor() {
    super();
    this.currentUnit = 'in'; // Default unit
  }

  connectedCallback() {
    // Query elements once the component is attached to the DOM
    this.navigationButtons = this.querySelectorAll('[size-chart-button]');
    this.convertableCells = this.querySelectorAll('[convertable-data-cell]');

    // Expose the total column count (size columns + the title column) so the
    // stylesheet can enforce a minimum cell width and scroll horizontally when
    // there are too many sizes to fit (see component-size-chart-modal.css).
    const headerCols = parseInt(this.getAttribute('header-cols'), 10);
    if (!isNaN(headerCols)) {
      this.style.setProperty('--size-chart-cols', headerCols + 1);
    }

    // Wrap only the table in its own scroll container so the horizontal scroll
    // doesn't drag the unit-switch tabs along with it.
    const table = this.querySelector('table.size-chart-table');
    if (table && !table.parentElement.classList.contains('size-chart-table__scroll')) {
      const scroller = document.createElement('div');
      scroller.className = 'size-chart-table__scroll';
      table.parentNode.insertBefore(scroller, table);
      scroller.appendChild(table);
    }

    // Add event listeners to buttons
    this.navigationButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        this.convertValues(e.target);
        this.toggleButtonState(e.target);
      });
    });
  }


  toggleButtonState(targetButton) {
    this.navigationButtons.forEach(button => {
      button.removeAttribute('active');
    });

    targetButton.setAttribute('active', '');
  }

  convertValues(target) {
    const targetUnit = target.getAttribute('size-chart-button');
    if (this.currentUnit == targetUnit) return;

    this.convertableCells.forEach(cell => {
      const sourceValue = cell.getAttribute('convertable-data-cell');
      let cellData = parseFloat(sourceValue);
      if (isNaN(cellData)) return;

      // Inches is the authored unit, so put the original value back rather than
      // dividing the centimetre figure, which loses precision on every switch.
      if (targetUnit !== 'cm') {
        cell.textContent = sourceValue + '"';
        return;
      }

      let convertedValue = cellData * 2.54;

      convertedValue = Math.round(convertedValue * 20) / 20;

      let formattedValue;
      if (Number.isInteger(convertedValue)) {
        formattedValue = convertedValue.toFixed(1);
      } else if (convertedValue * 10 % 1 === 0) {
        formattedValue = convertedValue.toFixed(1);
      } else {
        formattedValue = convertedValue.toFixed(2);
      }

      cell.textContent = formattedValue;
    });

    this.currentUnit = targetUnit;
  }


  });
}



